import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { tableStyles as s } from "../styles/TableStyles";
import { styles } from "../../SalesPeronsWithChallanData/styles/SalesPersonWithChallanData";
import ProductDataPopUp from "./ProductDataPopUp";
import { ExternalLinkIcon } from "../../SalesPeronsWithChallanData/components/SvgIcons";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import { darkBlueShade, DimGrayColor, lightBrownColor } from "../../../config/ColorObj";
import { getBillProductListById } from "../../../Slice/billingHistory.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { serverMsg, noInternetMsg } from "../../../config/messageconstant";

const OutletSellTable = ({ rows, getBillProductListById, showLoador, showNotification }) => {

    const [productPopFlag, setProductPopFlag] = useState(false);
    const [popupRowData, setPopupRowData] = useState([]);

    const onOutletClick = useCallback(async (row) => {
        if (!navigator.onLine) {
            showNotification({ msg: noInternetMsg, severity: "error" });
            return;
        }


        showLoador({ loador: true });
        const { response, success } = await getBillProductListById({ billHeaderId: row.headerId });
        showLoador({ loador: false });

        if (success) {
            setPopupRowData(response);
            setProductPopFlag(true);
        } else {
            showNotification({ msg: serverMsg, severity: "error" });
        }
    }, [getBillProductListById, showLoador, showNotification]);

    const onClose = useCallback(() => {
        setProductPopFlag(false);
        setPopupRowData([]);          // clear data when popup closes
    }, []);

    if (!rows?.length) {
        return <TypographyCompo style={s.emptyText}>No outlet data available.</TypographyCompo>;
    }

    return (
        <>
            <table style={s.table}>
                <thead>
                    <tr>
                        <th style={{ ...s.th, width: 40 }}>#</th>
                        <th style={s.th}>Outlet Name</th>
                        <th style={{ ...s.th, textAlign: "center" }}>Date</th>
                        <th style={{ ...s.th, textAlign: "center" }}>Sell Qty</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, i) => (
                        <tr
                            key={row.outletId ?? i}
                            style={i < rows.length - 1 ? s.row : undefined}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = "var(--sub-row-hover, #f8fafc)";
                                e.currentTarget.querySelector("[data-link]").style.color = darkBlueShade;
                                e.currentTarget.querySelector("[data-ext]").style.opacity = "1";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = "transparent";
                                e.currentTarget.querySelector("[data-link]").style.color = "inherit";
                                e.currentTarget.querySelector("[data-ext]").style.opacity = "0";
                            }}
                        >
                            <td style={{ ...s.td, color: lightBrownColor, fontSize: 12 }}>
                                {String(i + 1).padStart(2, "0")}
                            </td>
                            <td style={{ ...s.td, fontWeight: 500 }} onClick={() => onOutletClick(row)}>
                                <TypographyCompo style={styles.challanLink} data-link>
                                    {row.outletName}
                                    <TypographyCompo data-ext style={{ opacity: 0, transition: "opacity .15s" }}>
                                        <ExternalLinkIcon />
                                    </TypographyCompo>
                                </TypographyCompo>
                            </td>
                            <td style={{ ...s.td, textAlign: "center", color: DimGrayColor }}>{row.date}</td>
                            <td style={{ ...s.td, textAlign: "center" }}>
                                <TypographyCompo style={s.badge}>{row.sellQty}</TypographyCompo>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {productPopFlag && (
                <ProductDataPopUp
                    open={productPopFlag}   // ← was buggy `open` (undefined) before
                    handleCloses={onClose}
                    rowData={popupRowData}  // ← API response passed here
                />
            )}
        </>
    );
};

const mapDispatchToProps = {
    getBillProductListById,
    showLoador,
    showNotification,
};

export default connect(null, mapDispatchToProps)(React.memo(OutletSellTable));